import { OwnerAddressModel } from './owner-address.model';

export class CoOwnerModel {

  pesel: string;
  lastName: string;
  firstName: string;
  drivingLicenseIssueYear: number;
  drivingLicenseIssueMonth: number;
  nip: string;
  birthDate: string;
  companyName: string;
  partyTypeCode: string;

  address: OwnerAddressModel;

  constructor() {

    this.pesel = '';
    this.lastName = '';
    this.firstName = '';
    this.nip = null;
    this.birthDate = '';
    this.companyName = '';
    this.partyTypeCode = '';

    this.address = new OwnerAddressModel();
  }
}

export interface CoOwnerState {
  noDrivingLicense: boolean;
}
